import React from 'react';

const steps = [
  { n: '01', title: 'Scope', body: 'We map the actual problem, the current state, and what a good outcome looks like. You get a clearly scoped plan with defined objectives, not a vague statement of work.' },
  { n: '02', title: 'Build', body: 'Pipelines, models, dashboards, or AI systems, built to be reliable and handed over clean. No throwaway proofs of concept that rot in a month.' },
  { n: '03', title: 'Prove', body: 'We tie the work to a measurable result and show it against the baseline. If it did not move the number, we say so.' },
  { n: '04', title: 'Hand over', body: 'Documentation, definitions, and knowledge transfer so your team can run it after the engagement ends. The work should outlast the contract.' },
];

const Approach = () => (
  <section
    id="approach"
    className="zk-section-pad zk-section-gutter"
    style={{ maxWidth: '1180px', margin: '0 auto', padding: '120px 56px' }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
      <span style={{ fontFamily: 'var(--zk-mono)', fontSize: '12px', letterSpacing: '0.28em', color: '#ff3ea5' }}>
        {'// HOW_WE_WORK'}
      </span>
    </div>
    <p
      style={{
        maxWidth: '760px',
        margin: '0 0 64px',
        fontSize: '21px',
        lineHeight: 1.55,
        color: 'rgba(232,238,240,0.86)',
        fontWeight: 400,
        textWrap: 'pretty',
      }}
    >
      Most data problems are not really about tools. They are about unclear questions, data spread across systems that do not talk to each other, and no agreed source of truth. We start there. Every engagement is scoped to a defined outcome with a baseline and a way to measure whether it moved.
    </p>
    <div
      className="zk-grid-4"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 0,
        borderTop: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      {steps.map((step, i) => (
        <div
          key={step.n}
          className="zk-approach-cell"
          style={{
            padding:
              i === 0
                ? '30px 28px 30px 0'
                : i === steps.length - 1
                ? '30px 0 30px 28px'
                : '30px 28px',
            borderRight: i < steps.length - 1 ? '1px solid rgba(255,255,255,0.08)' : 'none',
          }}
        >
          <div style={{ fontFamily: 'var(--zk-mono)', fontSize: '28px', fontWeight: 500, color: '#ff3ea5', marginBottom: '16px' }}>
            {step.n}
          </div>
          <h3 style={{ margin: '0 0 10px', fontSize: '19px', fontWeight: 600 }}>{step.title}</h3>
          <p style={{ margin: 0, fontSize: '14px', lineHeight: 1.6, color: 'rgba(232,238,240,0.66)', textWrap: 'pretty' }}>
            {step.body}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default Approach;
